// Source-agnostic on purpose: copy that names the agent's sources goes stale the
// moment it gains one, and every workspace on the default has to be migrated.
export const defaultAiChatWelcomeMessage = (
	workspaceName?: string | null,
): string =>
	`Hi! I'm an AI agent. Ask me anything about ${workspaceName?.trim() || "the product"}. I can also file an engineering ticket when you hit a bug.`

// Seeded into every new workspace so the routine has one visible rule from the
// first thread. Names no specific tag, since it runs on every workspace.
export const ROUTINE_DEFAULT_PROMPT =
	"Apply a tag that matches what the thread is about."

// Product-agnostic on purpose: a new workspace has no docs, roadmap or changelog
// yet, so a starter that assumes one lands the visitor on an empty answer.
export const defaultAiChatExampleQuestions = [
	"How does pricing work?",
	"How do I report a bug?",
	"Can I talk to a human?",
] as const
